const getDefs = createTableList => {
  //console.log("~~~ " + JSON.stringify(createTableList));
  let tableDef = {
    users: {
      userName: {
        caption: "NAME",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      userEmail: {
        caption: "EMAIL",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      userEmployeeId: {
        caption: "EMPLOYEE ID",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      roleName: {
        caption: "ROLE NAME",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      userDesignation: {
        caption: "DESIGNITION",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      userNotes: {
        caption: "NOTES",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      searches: ["userName", "roleName", "userDesignation", "userNotes"]
    },
    contacts: {
      contactCompany: {
        caption: "COMPANY NAME",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      contactTrade: {
        caption: "TRADE (CATEGORY)",
        inputValidator: "",
        type: "input",
        enabled: true,
        selectorSource: {}
      },
      contactEmail: {
        caption: "EMAIL",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      contactPhone: {
        caption: "PHONE",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      contactMailingAddress: {
        caption: "MAILING ADDRESS",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      contactName: {
        caption: "CONTACT NAME",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      contactFax: {
        caption: "FAX",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      contactNotes: {
        caption: "NOTES",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      searches: [
        "contactCompany",
        "contactEmail",
        "contactMailingAddress",
        "contactName",
        "contactNotes",
        "contactPhone",
        "contactTrade"
      ]
    },
    suppliers: {
      supplierCompany: {
        caption: "COMPANY NAME",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      supplierTrade: {
        caption: "TRADE (CATEGORY)",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: "",
        type: "input",
        enabled: true
      },
      supplierName: {
        caption: "CONTACT PERSON",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      supplierEmail: {
        caption: "EMAIL",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      supplierFax: {
        caption: "FAX",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      supplierMailingAddress: {
        caption: "MAILING ADDRESS",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },

      supplierPhone: {
        caption: "PHONE",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      searches: [
        "supplierCompany",
        "supplierEmail",
        "supplierMailingAddress",
        "supplierMailingAddress",
        "supplierName",
        "supplierTrade"
      ]
    },
    notices: {
      noticeTitle: {
        caption: "SUBJECT",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      noticeDetails: {
        caption: "NOTICE DETAILS",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },

      updateDateTime: {
        caption: "UPDATED AT",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      searches: ["noticeTitle", "noticeDetails"]
    },
    projectInvoices: {
      invoiceId: {
        caption: "ID",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      totalInvoice: {
        caption: "TOTAL",
        format: "numeral",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      invoiceStatus: {
        caption: "STATUS",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      clientPo: {
        caption: "CLIENT PO",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      invoiceDate: {
        caption: "ISSUE DATE",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      projectName: {
        caption: "PROJECT",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      companyName: {
        caption: "COMPANY",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      contactName: {
        caption: "CONTACT",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      contactPhone: {
        caption: "PHONE",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      email: {
        caption: "EMAIL",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      searches: [
        "invoiceId",
        "projectName",
        "contactName",
        "totalInvoice",
        "companyName",
        "invoiceDate"
      ]
    },
    deletedprojectInvoices: {
      invoiceId: {
        caption: "ID",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      totalInvoice: {
        caption: "TOTAL",
        format: "numeral",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      invoiceStatus: {
        caption: "STATUS",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      clientPo: {
        caption: "CLIENT PO",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      invoiceDate: {
        caption: "ISSUE DATE",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      projectName: {
        caption: "PROJECT",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      companyName: {
        caption: "COMPANY",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      contactName: {
        caption: "CONTACT",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      contactPhone: {
        caption: "PHONE",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      email: {
        caption: "EMAIL",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      searches: [
        "invoiceId",
        "projectName",
        "contactName",
        "totalInvoice",
        "companyName",
        "invoiceDate"
      ]
    },
    projectClaims: {
      claimId: {
        caption: "ID",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      accSubConSum: {
        caption: "ACC SUBCON SUM",
        format: "numeral",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      claimDate: {
        caption: "CLAIM DATE",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },

      claimStatus: {
        caption: "STATUS",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      companyName: {
        caption: "COMPANY",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      contactName: {
        caption: "CONTACT",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      contactPhone: {
        caption: "PHONE",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      discountPercent: {
        caption: "DISC PERCENT",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      email: {
        caption: "EMAIL",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      projectName: {
        caption: "PROJECT",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      quoteId: {
        caption: "QUOTE ID",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      retentionPercent: {
        caption: "RETENTION PERCENT",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      totPmtRcvd: {
        caption: "TOT PMT RCVD",
        format: "numeral",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      searches: ["claimId", "companyName", "projectName", "contactName"]
    },
    projectDos: {
      doId: {
        caption: "DO ID",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      doDate: {
        caption: "DO DATE",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      companyName: {
        caption: "COMPANY",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      contactName: {
        caption: "CONTACT NAME",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      contactPhone: {
        caption: "CONTACT PHONE",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      email: {
        caption: "EMAIL",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      projectName: {
        caption: "PROJECT",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      searches: ["doId", "companyName", "contactName", "projectName"]
    },
    projectPos: {
      poId: {
        caption: "ID",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      poDate: {
        caption: "DATE",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      poAmount: {
        caption: "AMOUNT",
        format: "numeral",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      companyName: {
        caption: "SUPPLIER",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      contactName: {
        caption: "CONTACT NAME",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      contactPhone: {
        caption: "PHONE",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      projectName: {
        caption: "PROJECT",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      searches: [
        "projectName",
        "poId",
        "companyName",
        "contactName",
        "poAmount"
      ]
    },
    projectQuotes: {
      quoteId: {
        caption: "QUOTE ID",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      quoteDate: {
        caption: "QUOTE DATE",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      companyName: {
        caption: "COMPANY",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      contactName: {
        caption: "CONTACT NAME",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      contactPhone: {
        caption: "CONTACT PHONE",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      projectName: {
        caption: "PROJECT",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      quoteType: {
        caption: "TYPE",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      totalAmount: {
        caption: "TOTAL AMOUNT",
        format: "numeral",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },

      searches: [
        "quoteId",
        "companyName",
        "contactName",
        "projectName",
        "quoteType"
      ]
    },
    reports: {
      reportName: {
        caption: "REPORTNAME",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      categ: {
        caption: "CATEG",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      selectedCategory: {
        caption: "CATEGORY",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      selectedGroupBy: {
        caption: "GROUP BY",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      }
    },
    designReports: {
      reportName: {
        caption: "REPORTNAME",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      categ: {
        caption: "CATEG",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      selectedCategory: {
        caption: "CATEGORY",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      selectedGroupBy: {
        caption: "GROUP BY",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      }
    },
    logistics: {
      logisticsName: {
        caption: "NAME",
        selectorSource: {
          type: "table",
          table: "users",
          tableField: "userName",
          otherFieldsToUpdate: []
        },
        inputValidator: "",
        type: "search",
        enabled: true
      },
      logisticsDetails: {
        caption: "DETAILS",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      logisticsDateTime: {
        caption: "DATE & TIME",
        dateFormat: "dd-MM-yyyy h:mm a",
        dateFormatOut: "DD-MM-YYYY h:mm a",
        selectorSource: {
          type: "dateBetween",
          table: ""
        },
        inputValidator: "",
        type: "calendar",
        enabled: true
      },
      searches: ["logisticsName", "logisticsDetails"]
    },
    createFields: {
      name: {
        caption: "NAME",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      searches: ["name"]
    },
    createTable: {
      name: {
        caption: "TABLE NAME",
        selectorSource: {
          type: "",
          table: ""
        },
        inputValidator: ""
      },
      searches: ["name"]
    },
    listOfTables: {
      name: {
        caption: "TABLE NAME",
        inputValidator: "",
        type: "input",
        enabled: true,
        selectorSource: {
          staticSource: []
        }
      },
      caption: {
        caption: "TABLE CAPTION",
        inputValidator: "",
        type: "input",
        enabled: true,
        selectorSource: {
          staticSource: []
        }
      },
      menu: {
        caption: "MENU CAPTION",
        inputValidator: "",
        type: "input",
        enabled: true,
        selectorSource: {
          staticSource: []
        }
      },
      searches: ["name", "caption", "menu"]
    },
    menuDesigner: {
      name: {
        caption: "MENU NAME",
        inputValidator: "",
        type: "input",
        enabled: true,
        selectorSource: {
          staticSource: []
        }
      },
      searches: ["name"]
    }
  };

  if (createTableList && createTableList.length > 0) {
    for (let i = 0; i < createTableList.length; i++) {
      let dashColDefs = {};
      let dashColumns = createTableList[i]["dashColumns"];
      if (dashColumns && dashColumns !== undefined && dashColumns.length > 0) {
        for (let j = 0; j < dashColumns.length; j++) {
          dashColDefs[dashColumns[j]] = createTableList[i].fields.find(
            item => item.name === dashColumns[j]
          );
        }
        tableDef[createTableList[i].name] = dashColDefs;

        dashColDefs["searches"] = createTableList[i]["searchColumns"];
      }
    }
  }

  //console.log("~~~ " + JSON.stringify(tableDef));
  return tableDef;
};

export default getDefs;



// WEBPACK FOOTER //
// ./src/staticData/getDefs.jsx